import { QueryClient } from '@tanstack/react-query';

/**
 * One `QueryClient` shape for the app and for tests. Queries do not retry by default: a
 * failed request surfaces immediately as a Spanish error state rather than silently retrying
 * against a session or network problem the owner cannot see.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: false, refetchOnWindowFocus: true },
      mutations: { retry: false },
    },
  });
}
